//--------------- EXPORTAÇÃO DO UTILITÁRIO FORMAT CHART DATA ---------------//
// Responsável por garantir que cada item da lista tenha o campo quantidade como número válido, substituindo valores inválidos por "0"
export default function formatterChartData(data) {
    return data?.map(item => ({
        ...item,
        quantidade: Number(item.quantidade) || 0
    })) || [];
}